import { createResponseSchema } from "@/shared";
import { SectionSchema, Section } from "../schema/schema";
import { z } from "zod";

const SectionsResponseSchema = z.object({
  sections: z.array(SectionSchema),
  totalCount: z.number(),
  currentCount: z.number(),
  limit: z.number(),
  page: z.number(),
});

const SectionResponseSchema = z.object({
  section: SectionSchema,
});

const SectionRemoveResponseSchema = z.object({
  message: z.string(),
});

export interface SectionsResponseDto {
  status: string;
  data: {
    sections: Section[];
    totalCount: number;
    currentCount: number;
    limit: number;
    page: number;
  };
  message?: string | null;
}

export interface SectionResponseDto {
  status: string;
  data: {
    section: Section; 
  };
  message?: string | null;
}

export interface SectionRemoveResponseDto {
  status: string;
  data: {
    message: string;
  };
  message?: string | null;
}

export const SectionsResponseDto = createResponseSchema(SectionsResponseSchema);
export const SectionResponseDto = createResponseSchema(SectionResponseSchema);
export const SectionRemoveResponseDto = createResponseSchema(SectionRemoveResponseSchema);